import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Navigation } from '@quizzach/components';
import { RoutePath } from '@quizzach/interfaces';
import { useCartContext, useWindowListener } from '@quizzach/contexts';
import { scrollToTop } from '@quizzach/utils';
import { BtnTeal, Celebrate, FinishPage } from '@quizzach/styles';
import { Reveal } from '@quizzach/motion';

export const OrderFinish = () => {
	const { t } = useTranslation();
	const { touchDevice } = useWindowListener();
	const { refreshCartCount } = useCartContext();

	useEffect(() => {
		scrollToTop();
		// the completed order emptied the cart server-side
		refreshCartCount();
	}, []);

	// This route always confirms a single item (the old layout hook was
	// called with cart_items = 1), so only the singular strings apply.
	const title = touchDevice ? (
		<>{t('common.orderFinish.titleSingular')}</>
	) : (
		<>
			{t('common.orderFinish.titleSingularLine1')} <br />{' '}
			{t('common.orderFinish.titleSingularLine2')}
		</>
	);

	return (
		<FinishPage>
			<Navigation />
			<Celebrate>
				<Reveal as='span' className='hand'>
					ta daa!
				</Reveal>
				<Reveal as='h1' delay={1}>
					{title}
				</Reveal>
				<Reveal as='p' delay={2}>
					{t('common.orderFinish.explanationSingularPrefix')}{' '}
					<Link to={RoutePath.Profile}>
						{t('common.orderFinish.profileLink')}
					</Link>{' '}
					{t('common.orderFinish.explanationSuffix')}
				</Reveal>
				<Reveal delay={3} className='cta'>
					<BtnTeal as={Link} to={RoutePath.Profile}>
						{t('modal.gratisQuiz.goToProfile')}
					</BtnTeal>
				</Reveal>
			</Celebrate>
		</FinishPage>
	);
};
